import Vue from 'vue'
import Router from 'vue-router'
// import Hello from '@/components/Hello'

const Index = resolve => require(['../components/home/HomeIndex'], resolve)
const Login = resolve => require(['../components/Login'], resolve)
const BindPhone = resolve => require(['../components/BindPhone'], resolve)
const Service = resolve => require(['../components/service/Services'], resolve)



const Mine = resolve => require(['../components/mine/Mine'], resolve)
const Contact = resolve => require(['../components/mine/Contact'], resolve)
const SelfService = resolve => require(['../components/mine/SelfService'], resolve)
const ChangePhone = resolve => require(['../components/mine/ChangePhone'], resolve)
const Personal = resolve => require(['../components/mine/Personal'], resolve)
const HeadImg = resolve => require(['../components/mine/HeadImg'], resolve)
const Nick = resolve => require(['../components/mine/Nick'], resolve)
const Sex = resolve => require(['../components/mine/Sex'], resolve)
const BindStudent = resolve => require(['../components/mine/BindStudent'], resolve)
const AddStudent = resolve => require(['../components/mine/AddStudent'], resolve)
const Schedule = resolve => require(['../components/mine/Schedule'], resolve)
const Order = resolve => require(['../components/mine/Order'], resolve)
const OrderDetail = resolve => require(['../components/mine/OrderDetail'], resolve)
const Course = resolve => require(['../components/mine/Course'], resolve)
const CloudClassCourse = resolve => require(['../components/mine/CloudClassCourse'], resolve)
const CloudClassCourseDetail = resolve => require(['../components/mine/CloudClassCourseDetail'], resolve)
const Cart = resolve => require(['../components/mine/Cart'], resolve)
const Collect = resolve => require(['../components/mine/Collect'], resolve)
const Assessment = resolve => require(['../components/mine/Assessment'], resolve)
const Evaluation = resolve => require(['../components/mine/Evaluation'], resolve)
const TestEnter = resolve => require(['../components/mine/TestEnter'], resolve)
const Test = resolve => require(['../components/mine/Test'], resolve)
const TestResult = resolve => require(['../components/mine/TestResult'], resolve)
const AdjustCourse = resolve => require(['../components/mine/AdjustCourse'], resolve)
const AdjustClass = resolve => require(['../components/mine/AdjustClass'], resolve)
const SelectLecture = resolve => require(['../components/mine/SelectLecture'], resolve)

const SelectClassLecture = resolve => require(['../components/mine/SelectClassLecture'], resolve)
const TransferredCourse = resolve => require(['../components/mine/TransferredCourse'], resolve)
const TransferredClass = resolve => require(['../components/mine/TransferredClass'], resolve)
const ExternalScore = resolve => require(['../components/mine/ExternalScore'], resolve)
const Helper = resolve => require(['../components/mine/Helper'], resolve)
const Balance = resolve => require(['../components/mine/balance/Balance'], resolve)
const Recharge = resolve => require(['../components/mine/balance/Recharge'], resolve)
const RechargeConfirm = resolve => require(['../components/mine/balance/RechargeConfirm'], resolve)
const Coupon = resolve => require(['../components/mine/Coupon'], resolve)

const Location = resolve => require(['../components/course/Location'], resolve)
const Search = resolve => require(['../components/course/Search'], resolve)
const Nearby = resolve => require(['../components/course/Nearby'], resolve)
const PaidOrder = resolve => require(['../components/course/PaidOrder'], resolve)
const OrderConfirm = resolve => require(['../components/course/OrderConfirm'], resolve)
const Discount = resolve => require(['../components/course/Discount'], resolve)
const CourseDetail = resolve => require(['../components/course/CourseDetail'], resolve)
const TeacherDetail = resolve => require(['../components/course/TeacherDetail'], resolve)
const Custom = resolve => require(['../components/course/Custom'], resolve)
const Custom2 = resolve => require(['../components/course/Custom2'], resolve)
const Inform = resolve => require(['../components/course/Inform'], resolve)

const Teacher = resolve => require(['../components/raise/Teacher'], resolve)
const Recommend = resolve => require(['../components/recommend/Recommend'], resolve)

const UserForm = resolve => require(['../components/marketing/UserForm'], resolve)
const UserForm2 = resolve => require(['../components/marketing/UserForm2'], resolve)
const ChargingOk = resolve => require(['../components/marketing/ChargingOK'], resolve)

const GroupDetail = resolve => require(['../components/marketing/GroupDetail'], resolve)
const GroupSubmit = resolve => require(['../components/marketing/GroupSubmit'], resolve)
const GroupOrder = resolve => require(['../components/marketing/GroupOrder'], resolve)
const GroupSuccess = resolve => require(['../components/marketing/GroupSuccess'], resolve)
const GroupInvite = resolve => require(['../components/marketing/GroupInvite'], resolve)
const CouponActivity = resolve => require(['../components/marketing/CouponActivity'], resolve)
const Notice = resolve => require(['../components/course/Notice'], resolve)

// 合同签订 
const Contract = resolve => require(['../components/contract/Contract'], resolve)
const Guardian = resolve => require(['../components/contract/Guardian'], resolve)
const Preview = resolve => require(['../components/contract/Preview'], resolve)
const GuardianForm = resolve => require(['../components/contract/GuardianForm'], resolve)
const Sign = resolve => require(['../components/contract/Sign'], resolve)

Vue.use(Router)

export default new Router({

  mode: 'history',
  routes: [
    {path: '/',component: Index , meta : { keepAlive : true  }},
    {path: '/login',component: Login},
    {path: '/bind-phone',component: BindPhone},
    {path: '/service',component: Service},

    {path: '/mine',component: Mine},
    {path: '/contact',component: Contact},
    {path: '/self-service',component: SelfService},
    {path: '/change-phone',component: ChangePhone},
    {path: '/personal',component: Personal},
    {path: '/head-img',component: HeadImg},
    {path: '/nick',component: Nick},
    {path: '/order',component: Order},
    {path: '/sex',component: Sex},
    {path: '/bind-student',component: BindStudent},
    {path: '/add-student',component: AddStudent},
    {path: '/schedule',component: Schedule},
    {path: '/location',component: Location},
    {path: '/search',component: Search},
    {path: '/nearby',component: Nearby},
    {path: '/teacher',component: Teacher},
    {path: '/course',component: Course},
    {path: '/cloudclasscourse',component: CloudClassCourse},
    {path: '/cloudclasscoursedetail',component: CloudClassCourseDetail},
    {path: '/cart',component: Cart},
    {path: '/collect',component: Collect},
    {path: '/helper',component: Helper},
    {path: '/course-detail',component: CourseDetail},
    {path: '/inform',component: Inform},
    {path: '/order-confirm',component: OrderConfirm},
    {path: '/discount',component: Discount},
    {path: '/paid-order',component: PaidOrder},
    {path: '/teacher-detail',component: TeacherDetail},
    {path: '/order-detail',component: OrderDetail},
    {path: '/recommend',component: Recommend},
    {path: '/assessment',component: Assessment},
    {path: '/evaluation',component: Evaluation},
    {path: '/test-enter',component: TestEnter},
    {path: '/test',component: Test},
    {path: '/test-result',component: TestResult},
    {path: '/adjust-course',component: AdjustCourse},
    {path: '/adjust-class',component: AdjustClass},
    {path: '/select-lecture',component: SelectLecture},
    {path: '/select-class-lecture',component: SelectClassLecture},
    {path: '/transferred-course',component: TransferredCourse},
    {path: '/transferred-class',component: TransferredClass},
    {path: '/external-score',component: ExternalScore},
    {path:'/custom',component:Custom},
    {path:'/custom2',component:Custom2},
    {path:'/balance',component:Balance},
    {path:'/coupon',component:Coupon, name: 'Coupon'},
    {path:'/recharge',component:Recharge},
    {path:'/recharge-confirm',component:RechargeConfirm},
    {path:'/marketing/user-form',component:UserForm},
    {path:'/marketing/user-form2',component:UserForm2},
    {path:'/marketing/charging-ok',component:ChargingOk},
    {path:'/marketing/group-detail',component:GroupDetail, name: 'GroupDetail'},
    {path:'/marketing/group-submit',component:GroupSubmit, name: 'GroupSubmit'},
    {path:'/marketing/group-order',component:GroupOrder, name:'GroupOrder'},
    {path:'/marketing/group-success',component:GroupSuccess, name: 'GroupSuccess'},
    {path:'/marketing/group-invite',component:GroupInvite, name: 'GroupInvite'},
    {path:'/marketing/coupon-activity',component:CouponActivity, name: 'CouponActivity'},
    {path:'/notice',component: Notice, name: 'notice'},
    
    // 合同签订
    {path:'/contract',component: Contract, name: 'contract'},
    {path:'/contract/guardian',component: Guardian, name: 'contract-guardian'},
    {path:'/contract/preview',component: Preview, name: 'contract-preview'},
    {path:'/contract/guardian-form',component: GuardianForm, name: 'guardian-form'},
    {path:'/contract/sign',component: Sign, name: 'contract-sign'},


    {path: '*',component: Index},
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js